export default from './Avatar';



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentSettingsPage/components/ProfileForm/components/Avatar/index.js